import { AuditEntity } from './AuditEntity';

export interface DepartmentTemplate extends AuditEntity {
  name: string;
}

export enum DepartmentTemplateField {
  ID = 'id',
  NAME = 'name',
  CREATED_AT = 'createdAt',
}
